import { render, staticRenderFns } from "./SuccessInfoModalComponent.vue?vue&type=template&id=045a2b2c&scoped=true&"
import script from "./SuccessInfoModalComponent.vue?vue&type=script&lang=js&"
export * from "./SuccessInfoModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045a2b2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045a2b2c')) {
      api.createRecord('045a2b2c', component.options)
    } else {
      api.reload('045a2b2c', component.options)
    }
    module.hot.accept("./SuccessInfoModalComponent.vue?vue&type=template&id=045a2b2c&scoped=true&", function () {
      api.rerender('045a2b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/SuccessInfoModalComponent.vue"
export default component.exports